@if (serviceInformations) {
<div class="service-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Service.Title' | translate }} {{ serviceInformations.name ? '"' + serviceInformations.name + '"' : '' }}</span>
    </div>

    <div class="content">
        @if (serviceInformations !== undefined) {
        <form [formGroup]="serviceForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Service.NamePlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="name" autocomplete="off" [readonly]="!isCreation" required />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Service.SettingsPlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="settings" autocomplete="off" required />
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button type="button" color="accent" routerLink="/services">{{ 'Service.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!serviceForm.valid" type="submit">{{ 'Service.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
